module.exports = __webpack_public_path__ + "img/20190531162728943.167e6bd6.png";